<template>
  <a-modal
      title="批量用餐登记"
      :visible="showModal"
      @ok="clickOk"
      @cancel="showModal=false"
      class="customermodel"
      width="500px"
      :centered="true"
      >
      <div class="checkin-model">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-item label="餐次">
            <a-select v-model="curMeal" size="large">
              <a-select-option v-for="(item,key) in mealTypes" :value="key" :key="key">{{item}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="未到校用餐学生">
            <a-select mode="multiple" v-model="selects" size="large" option-filter-prop="children" showSearch @change="onStudentChange">
              <a-select-option v-for="item in students" :value="item._id" :key="item._id">{{item.name}}</a-select-option>
            </a-select>
            <!-- <div class="tag">
              <a-tag closable v-for="item in selects" :key="item.key" @close="closeTag(item)">{{item.name}}</a-tag>
            </div> -->
          </a-form-item>
          <a-form-item :wrapper-col="{ offset: 6 }">
            <div class="tips">
              操作后<span class="fprimary">不可修改</span
              >，请确认已登记请假或未到校用餐学生。
            </div>
          </a-form-item>
        </a-form>
      </div>
  </a-modal>
</template>
<script>
import apis from '@/business/apis'
import { mealTypes } from '@/business/enums'
import { mapState } from 'vuex'
export default {
  inject: ['eventBus'],
  data () {
    return {
      curId: '',
      students: [],
      selects: [],
      curMeal: '',
      mealTypes,
      showModal: false
    }
  },
  computed: {
    ...mapState('nutrition', [
      'currentClass',
      'selectedMeal'
    ]),
    ...mapState('school', [
      'currentSchool'
    ])
  },
  methods: {
    showRecordModal (data, schoolId) {
      this.selects = []
      this.curMeal = this.selectedMeal
      this.showModal = true
    },
    onStudentChange (key, vnode) {
      // const temp = this.students.filter(item => item._id.toString() === key.toString())
      // if (temp && temp[0]) {
      //   temp[0].selected = true
      // }
      // this.selects = this.students.filter(item => item.selected === true)
    },
    async clickOk () {
      const data = {
        group_id: this.currentClass._id,
        meal: this.curMeal,
        excludes: this.selects
      }
      const respose = await this.$http.post(apis.nutrition.manualRecordMeal, data)
      if (respose.body.err) {
        return
      }
      this.$message.success('登记成功')
      this.$emit('onRecordSuccess')
      this.showModal = false
    },
    async loadData () {
      const query = '?schoolId=' + this.currentSchool._id + '&groupId=' + this.currentClass._id
      const respose = await this.$http.get(apis.user.listByGroup + query)
      if (respose && respose.body) {
        this.students = respose.body.list || []
      }
    }
  },
  async created () {
    this.eventBus.$on('show-recordmeal-modal', this.showRecordModal)
    await this.loadData()
  },
  beforeDestroy () {
    this.eventBus.$off('show-recordmeal-modal', this.showRecordModal)
  }
}
</script>
